export default "__VITE_ASSET__BVnncIp$__"